module.exports = __webpack_public_path__ + "media/images/fv2-ec0eebac57f477b847340325e5735314.jpg";